import { ReactNode } from 'react'
import { useRouter } from 'next/router'
import NextLink from 'next/link'
import { clsx } from 'clsx'

import styles from './SidebarItem.module.css'

type SidebarItemProps = {
  children: ReactNode
  href: string
}

export const SidebarItem = ({ children, href }: SidebarItemProps) => {
  const { asPath } = useRouter()

  const isActive = () => {
    if (href === '/') {
      return asPath === '/'
    }

    return asPath.startsWith(href)
  }

  return (
    <li className={clsx(styles.sidebarListItem, isActive() && styles.active)}>
      <NextLink href={href} passHref>
        {children}
      </NextLink>
    </li>
  )
}
